import React from 'react'
import './CourtSectionCard.css'
import MockCaseTimeline from '@shared/MockCaseTimeline/MockCaseTimeline'
import CourtIcon from '@icons/court-section-icon.svg'
import SharedCardContent from '@shared/SharedCardContent/SharedCardContent'


function CourtSectionCard({ docketSeed }) {
    return (
        <div className='court-section-container'>
            <div className="court-section-left">
                <div className="overlay"></div>
                <div className="court-section-overlay-card">
                    <MockCaseTimeline seed={docketSeed} />
                </div>
            </div>
            <SharedCardContent icon={CourtIcon} badgeTitle={'PACER & State Court Integration'} title={'Automated Deadlines & Dockets'}
               text={"Just search for a case or start a new one. Vienna monitors supported dockets on configured schedules and surfaces new filings, orders, and deadlines as available."}
               subtext={'Reduce manual deadline checking and PACER refreshes for supported integrations.'}
            />
        </div>
    )
}

export default CourtSectionCard
